<template>
  <div class="container">
    <mt-header fixed :title="$route.meta.title">
      <span slot="left" @click="goBack" v-show="showBack">
        <mt-button icon="back">返回</mt-button>
      </span>
    </mt-header>
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <tabbar></tabbar>
    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2026034235号</a>
    </div>
  </div>
</template>

<script>
import tabbar from './components/tabbar.vue'

export default {
  data () {
    return {
      showBack: false
    }
  },
  created () {
    this.showBack = this.$route.path !== '/home'
    this.checkLogin()
  },
  watch: {
    '$route.path' (newVal) {
      this.showBack = newVal !== '/home'
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    checkLogin () {
      this.$http.get('user').then(res => {
        if (res.data.code === 1) {
          this.$store.commit('user/setUser', res.data.data)
        } else {
          this.$auth.clearAuthorization()
          this.$store.commit('user/logout')
        }
      }).catch(() => {
        this.$auth.clearAuthorization()
        this.$store.commit('user/logout')
      })
    }
  },
  components: {
    tabbar
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  box-sizing: border-box;
}

.container {
  padding-top: 40px;
  padding-bottom: 90px;
  overflow-x: hidden;
}

.fade-enter {
  opacity: 0;
  transform: translateX(100%);
}

.fade-leave-to {
  opacity: 0;
  transform: translateX(-100%);
  position: absolute;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.beian {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #fff;
  font-size: 12px;
  z-index: 1002;
  border-top: 1px solid #eee;
  
  a {
    color: #666;
    text-decoration: none;
    
    &:hover {
      color: #333;
    }
  }
}
</style>
